/**
 * BackgroundStaticVideo
 *
 * Renders bgstatic.mp4 as a full-bleed background video. Use inside a section
 * that has data-background-static-video="true" (and global styles for alpha bg).
 */

import React from "react";
import * as styles from "./BackgroundStaticVideo.module.scss";

export default function BackgroundStaticVideo() {
  return (
    <div className={styles.wrapper} aria-hidden>
      <video
        src="/videos/bgstatic.mp4"
        autoPlay
        loop
        muted
        playsInline
        className={styles.video}
      />
      <div className={styles.overlay} />
    </div>
  );
}
